import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";

export const romaniaFields = {
  roPnc: taxIdFieldConfig("RO", "roPnc"),
  roConfirmPnc: confirmTaxIdFieldConfig("RO", "roPnc"),
};
